import React from "react";

export default function LoginContainer({ children }) {
  return (
    <div className="teacher-login-container">
      <a href="https://www.edsider.com/" className="teacher-login-logo" aria-label="EdSider">
        <img src="/assets/media/logos/edsiderlogo.png" alt="Edsider Logo" />
      </a>

      <div className="teacher-login-welcome">
        <div className="teacher-login-title">Welcome!</div>
        <p className="teacher-login-subtitle">Sign In to continue to your account ls</p>
        <div className="teacher-login-gradient-line" />
      </div>

      <div className="teacher-login-card">
        <div className="teacher-login-card-image-wrap">
          <img
            src="/assets/media/bg/teachers.png"
            className="teacher-login-card-image"
            alt="Learning illustration"
          />
        </div>

        <div className="teacher-login-card-body">{children}</div>
      </div>
    </div>
  );
}
